function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M79 36v-4c-1.7 0-3-1.3-3-3H19c-5.5 0-10 4.5-10 10v14c7.2 0 13 5.8 13 13S16.2 79 9 79v10c0 5.5 4.5 10 10 10h57c0-1.7 1.3-3 3-3v-4c-1.7 0-3-1.3-3-3s1.3-3 3-3v-4c-1.7 0-3-1.3-3-3s1.3-3 3-3v-4c-1.7 0-3-1.3-3-3s1.3-3 3-3v-4c-1.7 0-3-1.3-3-3s1.3-3 3-3v-4c-1.7 0-3-1.3-3-3s1.3-3 3-3v-4c-1.7 0-3-1.3-3-3s1.3-3 3-3z"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#e6e6ef",
  d: "M64 52H34c-1.7 0-3-1.3-3-3s1.3-3 3-3h30c1.7 0 3 1.3 3 3s-1.3 3-3 3zm0 20H34c-1.7 0-3-1.3-3-3s1.3-3 3-3h30c1.7 0 3 1.3 3 3s-1.3 3-3 3zM54 82H34c-1.7 0-3-1.3-3-3s1.3-3 3-3h20c1.7 0 3 1.3 3 3s-1.3 3-3 3zm10 0c-.2 0-.4 0-.6-.1-.2 0-.4-.1-.6-.2-.2-.1-.3-.2-.5-.3-.2-.1-.3-.2-.5-.4-.5-.4-.8-1.2-.8-2s.3-1.6.9-2.1c1.1-1.1 3.1-1.1 4.2 0 .6.6.9 1.3.9 2.1s-.3 1.6-.9 2.1c-.5.6-1.3.9-2.1.9zM44 62H34c-1.7 0-3-1.3-3-3s1.3-3 3-3h10c1.7 0 3 1.3 3 3s-1.3 3-3 3zm20 0H54c-1.7 0-3-1.3-3-3s1.3-3 3-3h10c1.7 0 3 1.3 3 3s-1.3 3-3 3z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "#6dc289",
  d: "M119 39c0-5.5-4.5-10-10-10H82c0 1.7-1.3 3-3 3v4c1.7 0 3 1.3 3 3s-1.3 3-3 3v4c1.7 0 3 1.3 3 3s-1.3 3-3 3v4c1.7 0 3 1.3 3 3s-1.3 3-3 3v4c1.7 0 3 1.3 3 3s-1.3 3-3 3v4c1.7 0 3 1.3 3 3s-1.3 3-3 3v4c1.7 0 3 1.3 3 3s-1.3 3-3 3v4c1.7 0 3 1.3 3 3h27c5.5 0 10-4.5 10-10V39z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fill: "#444b54",
  d: "M109 102H89c-1.7 0-3-1.3-3-3s1.3-3 3-3h20c3.9 0 7-3.1 7-7V39c0-3.9-3.1-7-7-7H89c-1.7 0-3-1.3-3-3s1.3-3 3-3h20c7.2 0 13 5.8 13 13v50c0 7.2-5.8 13-13 13zm-40-6H19c-3.9 0-7-3.1-7-7v-7.3c7.4-1.4 13-7.9 13-15.7 0-7.8-5.6-14.3-13-15.7V39c0-3.9 3.1-7 7-7h50c1.7 0 3-1.3 3-3s-1.3-3-3-3H19c-7.2 0-13 5.8-13 13v14c0 1.7 1.3 3 3 3 5.5 0 10 4.5 10 10S14.5 76 9 76c-1.7 0-3 1.3-3 3v10c0 7.2 5.8 13 13 13h50c1.7 0 3-1.3 3-3s-1.3-3-3-3z"
});

function SvgTicket(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128 128"
  }, props), _ref, _ref2, _ref3, _ref4);
}

export default SvgTicket;